<template>
    <Layout>
        <!-- ICON -->
        <template #icon>build</template>

        <!-- TITLE -->
        <template #title>{{ $t('PartsLookup.Title') }}</template>
        
        <!-- BODY -->
        <template #body>
            <PartsLookup />
        </template>
    </Layout>
</template>
  
<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
    name: "Catalog",
    components: {
        Layout: () => import("@/layouts/Layout.desktop"),
        PartsLookup: () => import('./PartsLookup.vue')
    },
    computed: {
        ...mapGetters({
            isVehicleSelected: 'vehicle/isVehicleSelected',
            selectedVehicleText: 'vehicle/selectedVehicleText'
        }),
        ...mapState({
            skin: state => state.settings.skin
        }),
        breadcrumbs() {
            return [
                {
                    text: this.$i18n.tc("Dashboard.Title"),
                    disabled: false,
                    to: "/"
                },
                {
                    text: `${this.$i18n.tc("PartsResults.Title")} for ${this.selectedVehicleText}`,
                    disabled: true
                }
            ];
        }
    },
    methods: {
        ...mapActions({
            REMOVE_SPECIFIC_CONDITION_QUESTIONS: "parts/REMOVE_SPECIFIC_CONDITION_QUESTIONS"
        })
    },
    async mounted() {
        await this.REMOVE_SPECIFIC_CONDITION_QUESTIONS();
    },
    async activated() {
        await this.REMOVE_SPECIFIC_CONDITION_QUESTIONS();
    }
};
</script>
    